<div class="menu_dialog" [class.delete-trusted]="option.deleteTrusted">
  @if (!option.deleteTrusted) {
  <div mat-dialog-title class="flex-end">
    <button
      id="menu_{{ itemIndex }}-close-btn"
      mat-icon-button
      mat-dialog-close
      class="close-btn"
      [title]="'COMMON.BUTTON.DIALOG.CLOSE' | translate"
      [attr.aria-label]="'COMMON.BUTTON.DIALOG.CLOSE' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  }

  <div mat-dialog-content>
    <div class="menu__content">
      @if (!isErrorInline && data.errorKey) {
      <pbb-notice
        [title]="data.errorKey | translate"
        [inline]="isErrorInline"
        id="dialog_action_message"
        [type]="notice.ERROR"
        [showInContainer]="false"
      ></pbb-notice>
      } @if (!option.showLogo && !option.deleteTrusted) {
      <mat-icon class="confirm-icon">{{ option.icon }}</mat-icon>
      }

      <h1 class="mat-body-1 text-bold mb-4" id="menu_{{ option.action | lowercase }}_title">
        {{ getTranslation(option, 'confirmTitle') }}
      </h1>
      <span class="mat-body-2 text-grey-subtitle mb-24" id="menu_{{ option.action | lowercase }}_info">
        {{ getTranslation(option, 'confirmSubtitle') }}
      </span>
      @if (option.showLogo) {
      <pbb-bank-info [logo]="option.logo" [imageSrc]="option.imageSrc" [name]="item.display_name"></pbb-bank-info>
      } @if (option.deleteTrusted) {
      <pbb-card class="card card_column card_normal" id="trusted-device-card">
        <mat-card-content>
          <div class="trusted-device-details">
            <span matListItemLine id="trusted-device-user-agent" class="mat-body-1 text-bold">
              {{ item.user_agent | uaParser }}
            </span>
            @if (item.trusted !== null) {
            <span matListItemLine id="trusted-device-biometrics" class="mat-body-2 text-grey-subtitle">
              {{
                (item?.webauth_enabled
                  ? 'USER_PORTAL.MANAGE_TRUSTED_DEVICES.BIO_ENABLED'
                  : 'USER_PORTAL.MANAGE_TRUSTED_DEVICES.BIO_DISABLED'
                ) | translate
              }}
            </span>
            <span matListItemLine id="trusted-device-last-login-info" class="mat-body-2 text-grey-subtitle">
              {{ 'USER_PORTAL.TRUSTED_DEVICES.LAST_LOGGED_IN' | translate }}
              {{ item?.last_login_info?.timestamp | timeAgo }}
            </span>
            } @if (item.current) {
            <mat-basic-chip matListItemLine class="device-chip mt-16" id="trusted-device-default-chip">
              <mat-icon class="icon-sm text-black">check_circle</mat-icon>
              <span class="mat-caption text-info">{{
                'USER_PORTAL.MANAGE_TRUSTED_DEVICES.THIS_DEVICE' | translate
              }}</span>
            </mat-basic-chip>
            }
          </div>
        </mat-card-content>
      </pbb-card>
      } @if (isErrorInline && dialogMessageKey) {
      <pbb-notice
        [inline]="isErrorInline"
        [title]="
          dialogMessageKey
            | translate : (isSuccess ? option.dialogSuccessMessageParams : option.dialogErrorMessageParams)
        "
        id="dialog_action_message"
        [type]="isSuccess ? notice.INFO : notice.ERROR"
        [showInContainer]="false"
      ></pbb-notice>
      } @if (!option.deleteTrusted && (!!option.confirmButton || !!option.confirmCancel)) {
      <div class="buttons-container">
        @if (!!option.confirmCancel) {
        <button
          mat-dialog-close
          class="cancel-button"
          mat-flat-button
          id="menu_{{ option.action | lowercase }}_cancel-btn"
        >
          {{ isSuccess ? ('COMMON.BUTTON.CLOSE' | translate) : getTranslation(option, 'confirmCancel') }}
        </button>
        } @if (!!option.confirmButton) {
        <button
          class="unlink-button"
          mat-flat-button
          cdkFocusInitial
          (click)="confirm(option)"
          [disabled]="isSuccess"
          id="menu_{{ option.action | lowercase }}_confirm-btn"
        >
          {{ 'COMMON.BUTTON.REMOVE' | translate }}
        </button>
        }
      </div>
      } @if (option.deleteTrusted) {
      <div class="{{ option.deleteTrusted ? 'flex flex-end mt-24' : '' }}">
        <button
          mat-stroked-button
          mat-dialog-close
          class="btn-stroked-no-border mr-8"
          [color]="option.confirmCancelColor"
          id="menu_{{ option.action | lowercase }}_cancel-btn"
        >
          {{ isSuccess ? ('COMMON.BUTTON.CLOSE' | translate) : getTranslation(option, 'confirmCancel') }}
        </button>
      </div>
      }
    </div>
  </div>
</div>
